<template>
  <div class="login" @keydown="submitFomrEnter">
    <!-- <img class="loginBg" src="@/assets/img/loginBg.jpeg"> -->
    <div class="form">
      <div class="logo"></div>
      <p class="form-tit">
        {{ $store.state.title }}
      </p>
      <el-form ref="form" :model="form" :rules="formRule">
        <el-form-item label="" prop="user">
          <el-input
            prefix-icon="el-icon-user"
            v-model="form.user"
            clearable
            placeholder="请输入用户名"
          ></el-input>
        </el-form-item>
        <el-form-item label="" prop="pass">
          <el-input
            prefix-icon="el-icon-key"
            v-model="form.pass"
            clearable
            show-password
            placeholder="请输入密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="" prop="code">
          <div class="form-code">
            <el-input class="form-code-input" v-model="form.code"></el-input>
            <el-image
              class="form-code-img"
              fit="fill"
              :src="imgCodeUrl"
              @click="handleImgCode"
            ></el-image>
          </div>
        </el-form-item>
        <el-form-item label="">
          <div class="form-checked">
            <el-checkbox @change="chenck" v-model="form.checked"
              >保持登录</el-checkbox
            >
          </div>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" @click="submitFomr">登录</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: "login",
  data() {
    return {
      form: {
        user: "",
        pass: "",
        code: "",
        checked: true,
      },
      formRule: {
        user: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        pass: [{ required: true, message: "请输入密码", trigger: "blur" }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
      imgCodeUrl: "",
      // 存储过程接口验证码
      auth: "",
    };
  },
  mounted() {
    this.handleImgCode(); //获取验证码
    //一个小功能，快捷输入账号密码
    // if (process.env.NODE_ENV === "development") {
    //   this.form.user = "admin";
    //   this.form.pass = "123456";
    // }
    if (window.localStorage.getItem("isMarkPwd")) {
      this.form.user = window.localStorage.getItem("markUser");
      this.form.pass = window.localStorage.getItem("markPwd");
    }
  },
  methods: {
    chenck() {},
    /**
      切换验证码
     */
    handleImgCode() {
      this.$request({
        method: "post",
        url: "Users/LoginImgCode",
      }).then((res) => {
        this.imgCodeUrl = "data:image/png;base64," + res.Img;
        this.auth = res.SessionID;
      });
    },
    /**提交*/
    submitFomr() {
      //节流函数，解决按下回车重复触发登录的问题
      this.$throttle(() => {
        this.$refs.form.validate((valid) => {
          if (valid) {
            let data = {
              type: "AdminLogin",
              username: this.form.user,
              password: this.form.pass,
              code: this.form.code,
            };
            let proc = "Proc_Admin_MembersQuery"; // 存储过程名
            let type = "login";
            this.$requestSys({
              method: "post",
              url:
                "main/ashx/UserJson.ashx?type=" +
                type +
                "&json=" +
                encodeURIComponent(JSON.stringify(data)) +
                "&proc=" +
                proc,
              headers: {
                Auth: this.auth,
              },
            })
              .then((res) => {
                if (res.flag == 0) {
                  //成功后跳转
                  window.localStorage.setItem("auth", this.auth);
                  window.localStorage.setItem(
                    "entId",
                    res.data[0].entId.trim()
                  );

                  window.localStorage.setItem(
                    "userId",
                    res.data[0].userId.trim()
                  );
                  window.localStorage.setItem("name", res.data[0].name.trim());
                  window.localStorage.setItem(
                    "userName",
                    res.data[0].username.trim()
                  );
                  // 现在接口没有返回该信息
                  // window.localStorage.setItem(
                  //   "roleName",
                  //   res.data[0].RoleName && res.data[0].RoleName.trim()
                  // );
                  // 新加的接口使用这个token
                  window.localStorage.setItem("token", res.Token);
                  if (this.form.checked) {
                    window.localStorage.setItem("markUser", this.form.user);
                    window.localStorage.setItem("markPwd", this.form.pass);
                    window.localStorage.setItem("isMarkPwd", 1);
                  } else {
                    window.localStorage.removeItem("markUser");
                    window.localStorage.removeItem("markPwd");
                    window.localStorage.removeItem("isMarkPwd");
                  }
                  this.$getAddressData();
                  this.$router.replace({
                    path: "/home",
                  });
                  this.$message({
                    message: "登录成功",
                    type: "success",
                  });
                } else {
                  this.$message({
                    message: res.message,
                    type: "error",
                  });
                  this.handleImgCode();
                }
                // window.console.log(res)
              })
              .catch((err) => {
                window.console.log(err);
              });
          } else {
            this.$message({
              message: "补全字段",
              type: "error",
            });
          }
        });
      });
    },
    /**重置*/
    resetForm() {
      this.$refs.form.resetFields();
    },
    /** 回车登录 */
    submitFomrEnter(el) {
      if (el.keyCode == 13) {
        this.submitFomr();
      }
    },
  },
};
</script>

<style scoped>
.login {
  position: relative;
  width: 100%;
  height: 100%;
  /* background: url("https://images.pexels.com/photos/443356/pexels-photo-443356.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940") no-repeat center; */
  background: url("../assets/img/loginBg.jpeg") no-repeat center;
  /* https://images.pexels.com/photos/36487/above-adventure-aerial-air.jpg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940 */
  /* https://images.pexels.com/photos/443356/pexels-photo-443356.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940 */
  background-size: 100% auto;
}
.loginBg {
  position: absolute;
  width: 100%;
  height: 100%;
}
/************** 表单样式 *****************/
.form {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -190px;
  margin-top: -135px;
  width: 340px;
  height: 260px;
  padding: 20px;
  background: rgba(255, 255, 255, 0.19);
}
.logo {
  position: absolute;
  top: -100px;
  left: 50%;
  margin-left: -111px;
  width: 180px;
  height: 95px;
  background: url("~assets/logo.png") no-repeat center;
  background-size: 100% 100%;
}
.form-tit {
  text-align: center;
  padding-bottom: 10px;
  font-size: 14px;
  color: #c0c4cc;
}
.form::before {
  content: "";
  display: inline-block;
  position: absolute;
  border: 10px solid transparent;
  border-bottom-color: rgba(255, 255, 255, 0.19);
  left: 50%;
  top: -20px;
  margin-left: -10px;
  z-index: 99;
  width: 0;
  height: 0;
}
.form-code {
  display: flex;
  align-items: center;
}
.form-code-input {
  width: 200px;
}
.form-code-img {
  width: 80px;
  height: 32px;
  margin-left: 20px;
  border-radius: 3px;
}
.form-checked {
  display: flex;
  justify-content: flex-start;
  padding-left: 3px;
  box-sizing: border-box;
}
/************** 登录框样式 *****************/
.el-input >>> .el-input__inner {
  background-color: rgba(255, 255, 255, 0.1);
}
</style>
